import Header from "../components/header";
import React from "react";

const PrivacyPolicy = () => {
  <Header/>
  return (
    <div className="bg-[#F2F1F6] py-8 lg:py-16 lg:px-12">
      <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-[#ba56d4] text-center">
        Privacy Policy
      </h1>
      <div className="text-gray-700">
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          At Bot or Not, we prioritize your privacy and are committed to
          safeguarding it. This Privacy Policy outlines how we handle and
          protect your personal data when you use our game. We believe in
          transparency and aim to provide you with a clear understanding of how
          your information is managed.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Data Collection
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We want to assure you that Bot or Not does not collect any personal or
          non-personal data from its users. Our game is designed to respect your
          privacy by not gathering, storing, or sharing any user information.
          Your experience is solely based on gameplay without any data
          collection.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Children's Privacy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Bot or Not does not specifically address children's privacy because we
          do not collect any personal information from any users, including
          children. Our game operates under the principle of no data collection,
          ensuring a privacy-conscious environment for all users.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Changes to This Privacy Policy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may periodically update our Privacy Policy to reflect changes in
          our practices or for other operational, legal, or regulatory reasons.
          Any updates will be posted on this page, and we encourage you to
          review this policy regularly. By continuing to use our game after
          changes are made, you agree to the updated policy.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Contact Us
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you have any questions or concerns about our Privacy Policy or our
          practices, please do not hesitate to reach out to us. You can contact
          us at:
          <a
            href="mailto:info@thekaizenglobal.com"
            className="text-[#ba56d4] hover:underline"
          >
            {" "}
            info@thekaizenglobal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
